export class StatusMsg {
  private constructor(public readonly value: string) {}

  static success = new StatusMsg("success");
  static warning = new StatusMsg("warning");
  static info = new StatusMsg("info");
  static error = new StatusMsg("error");

  static getType(value: string): StatusMsg {
    switch (value) {
      case "success":
        return StatusMsg.success;
      case "warning":
        return StatusMsg.warning;
      case "info":
        return StatusMsg.info;
      case "error":
        return StatusMsg.error;
      default:
        return StatusMsg.info;
    }
  }
}

